function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const FirestoreIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.44 6.88L15.98 0l14.58 6.88v6.03L16 6.45 1.44 12.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44 17.8l14.54-6.95 14.58 6.95v6.07l-14.58-6.51-14.54 6.51zM14.15 26.31l5-2.22 6.57 3.23L14.15 32z"
  }));
};
export default FirestoreIcon;